import React from 'react';
import { formatTimecode, formatTimeOnly } from '../utils/timecodeFormatter';

interface TimecodeDisplayProps {
  value: number;
  fps?: number;
  startFrame?: number;
  dropFrame?: boolean;
  className?: string;
  onClick?: () => void;
}

export function TimecodeDisplay({
  value,
  fps,
  startFrame = 0,
  dropFrame = false,
  className,
  onClick,
}: TimecodeDisplayProps) {
  const currentTC = fps
    ? formatTimecode(value, fps, startFrame, dropFrame)
    : formatTimeOnly(value);

  const isClickable = !!onClick;

  const classes = [
    'kollab-player-timecode',
    isClickable ? 'kollab-player-timecode--clickable' : '',
    className ?? '',
  ].filter(Boolean).join(' ');

  return (
    <span
      className={classes}
      aria-label={currentTC}
      onClick={onClick}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
    >
      {currentTC}
    </span>
  );
}
